import styles from '../styles.module.scss';
import cn from 'classnames';
import { forwardRef, InputHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: FieldError;
  additionalClass?: string;
  isSmallSize?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ error, additionalClass = '', isSmallSize = false, readOnly, style, ...rest }, ref) => (
    <input
      ref={ref}
      type="text"
      readOnly={readOnly}
      className={cn('form-control form-control-solid', additionalClass, {
        [styles.invalidInput]: error?.message,
        'form-control-sm': isSmallSize
      })}
      style={readOnly ? { backgroundColor: '#E1E3EA', ...style } : style}
      {...rest}
    />
  )
);

TextInput.displayName = 'TextInput';
